<template>
  <div class="container mt-5">
    <h2>Contact Us</h2>
    <form @submit.prevent="submitForm">
      <div class="mb-3">
        <label for="name" class="form-label">Name</label>
        <input
          type="text"
          class="form-control"
          id="name"
          v-model="form.name"
          required
        />
      </div>
      <div class="mb-3">
        <label for="email" class="form-label">Email address</label>
        <input
          type="email"
          class="form-control"
          id="email"
          v-model="form.email"
          required
        />
      </div>
      <div class="mb-3">
        <label for="subject" class="form-label">Subject</label>
        <input
          type="subject"
          class="form-control"
          id="subject"
          v-model="form.subject"
          required
        />
      </div>
      <div class="mb-3">
        <label for="message" class="form-label">Message</label>
        <textarea
          class="form-control"
          id="message"
          v-model="form.message"
          rows="3"
          required
        ></textarea>
      </div>
      <button type="submit" class="btn btn-primary">Send Message</button>
    </form>

    <div v-if="successMessage" class="alert alert-success mt-3" role="alert">
      {{ successMessage }}
    </div>

    <div v-if="errorMessage" class="alert alert-danger mt-3" role="alert">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { BASE_URL } from '@/config';

export default {
  data() {
    return {
      form: {
        name: '',
        email: '',
        subject: '',
        message: '',
      },
      successMessage: '',
      errorMessage: '',
    };
  },
  methods: {
    async submitForm() {
      try {
        // Send form data to Strapi API
        const response = await axios.post(BASE_URL+'/api/send-email', this.form);
        this.successMessage = response.data.message;
        this.errorMessage = '';
        // Reset the form
        this.form.name = '';
        this.form.email = '';
        this.form.subject = '';
        this.form.message = '';
      } catch (error) {
        this.errorMessage = 'Failed to send message. Please try again later.';
        this.successMessage = '';
      }
    },
  },
};
</script>

<style scoped>
/* Add any custom styling here */
</style>

